// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.imageDiv {\n  width: 22%;\n  float: left;\n  margin: 1%;\n  height: 130px;\n  text-align: center;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 10px;\n  border-color: #bebebe;\n}\n.image {\n  height: 130px;\n}\n", ""]);
// Exports
module.exports = exports;
